import { isNewestFacebookConversation } from './isNewestFacebookConversation';
export function canClaimConversation(conversation, isAssignedToMe, latestFacebookCsid) {
    if (isAssignedToMe) {
        return false;
    }
    if (!conversation.is_closed) {
        return true;
    }
    const initialChannel = conversation.initial_channel;
    if (!initialChannel) {
        return false;
    }
    if ([
        'email',
        'voicemail',
        'contactform',
        'widgetchat',
        'pstnphone',
        'callback',
    ].includes(initialChannel)) {
        return true;
    }
    if (initialChannel === 'facebookmessenger') {
        return isNewestFacebookConversation(conversation, latestFacebookCsid);
    }
    return false;
}
